import React from 'react';
import PropTypes from 'prop-types';

const Container = ({ className, children, ref }) => (
  <div className={className} ref={ref}>
    {children}
  </div>
);

Container.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  ref: PropTypes.any,
};

Container.defaultProps = {
  className: '',
  ref: null,
};

export default Container;
